import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { useAuth } from '../hooks/useAuth';
import { hasAdminAccess } from '../utils/roleUtils';
import { PhotographerManagement } from '../components/PhotographerManagement';

const Photographers = () => {
  const { user } = useAuth();

  // Only admin users can access this page
  if (!hasAdminAccess(user)) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" color="error" gutterBottom>
          Access Denied
        </Typography>
        <Typography variant="body1">
          Only administrators can access the Photographers page.
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box mb={4}>
        <Typography variant="h4" gutterBottom>
          Photographer Management
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage your agency's photographers. Add, edit, or remove photographers from your team.
        </Typography>
      </Box>
      
      <PhotographerManagement />
    </Container>
  );
};

export default Photographers;
